import React from 'react';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import ShowOptionalField from '../ShowOptionalField'
import ShowOptionalLabel from '../ShowOptionalLabel'
import LoadingFrame from '../LoadingFrame'
import {Link} from 'react-router-dom'
import ModalConfirm from '../ModalConfirm'

const RubricaDetail = ({ loading, item, onClickDelete, showButtons = true, readOnly = false }) => {



    if (item === undefined || item.soggetto === undefined) return <div>
        <div className="ui cards">
            <div className="ui card">
                <div className="content">
                    &nbsp;
                </div>
            </div>
        </div>
        <LoadingFrame visible={loading}/>
    </div>

    let s = item.soggetto;
    let d = item.dipartimento;
    let o = item.organizzazione;

    let btnModifica = null;
    let btnElimina = null;

    if (readOnly == false){
        btnModifica =(
                            <div className="center aligned five wide column">
                                <Link to={"/app/rubrica/edit/" + s.idSoggetto} className="ui tiny primary button"><i
                                    className="edit icon"/>Modifica</Link>
                            </div>
        );
        btnElimina = (
                            <div className="center aligned five wide column">
                                <ModalConfirm
                                    msg={"Stai per cancellare il soggetto: " + s.nomeCompleto}
                                    onClickOk={(ev) => (onClickDelete(ev, item))}
                                >
                                    <a className="ui tiny red button"><i className="trash icon"/>Elimina</a>
                                </ModalConfirm>
                            </div>
        );
    }

    return <div>
        <div className="ui cards">
            <div className="ui card">
                <div className="content">
                    <div className="header">
                        <i className={"user icon" }/>
                        &nbsp;{s.nome}&nbsp;{s.cognome}
                    </div>
                    <div className="description">
                        <div className="ui two column grid">
                            <div className="column">
                                Titolo: <b>{item.titolo !== undefined ? item.titolo.titolo : ''}</b>
                            </div>
                            <div className="column">
                                Sesso: <b>{s.sesso}</b>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="header">
                        Indirizzo
                    </div>
                    <div className="description">
                        <p>{s.indirizzo} {s.cap} {s.citta} {s.provincia} {s.stato}</p>
                        <p><ShowOptionalField label="C.Fisc." value={s.cfisc}/>
                        </p>
                    </div>
                </div>
                <div className="content">
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Telefono 1</label><ShowOptionalLabel value={s.telefono1} icon="voulme control phone" extraClassName="right floated" />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Telefono 2</label><ShowOptionalLabel value={s.telefono2} icon="voulme control phone" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Cellulare</label><ShowOptionalLabel value={s.cellulare} icon="voulme control phone" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">FAX</label><ShowOptionalLabel value={s.fax} icon="fax" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">e-mail</label><ShowOptionalLabel value={s.email} icon="mail" extraClassName="right floated"  />
                    </div>
                </div>
                <div className="content">
                    <div className="ui vertical basic segment">
                        Creato il {s.creatoIl ?  <b><LocalDate data={s.creatoIl } /> <LocalTime data={s.creatoIl } /></b> : <b>?</b>} da <b>{s.creatoDa ? s.creatoDa.username : '?'}</b>
                    </div>
                    <div className="ui vertical basic segment">
                        <p>Modificato il {s.modificatoIl ?  <b><LocalDate data={s.modificatoIl } /> <LocalTime data={s.modificatoIl } /></b> : <b>?</b>} da <b>{s.modificatoDa ? s.modificatoDa.username : '?'}</b></p>
                    </div>
                </div>
                <div className="content">
                    <p>{s.note}</p>
                </div>


                    {showButtons ? (
                        <div className="extra content">
                        <div className="ui grid">
                            <div className="center aligned five wide column">
                                <Link to={"/app/rubrica"} className="ui tiny primary button"><i
                                    className="table icon"/>Elenco</Link>
                            </div>
                            {btnModifica}
                            {btnElimina}
                        </div>
                        </div>
                    ) : null}

            </div>
            <div className="ui card">
                <div className="content">
                    <div className="header">
                        <i className={"building icon" }/>
                        {d.nomeCompleto}
                    </div>
                </div>
                <div className="content">
                    <div className="header">
                        Indirizzo
                    </div>
                    <div className="description">
                        <p>{d.indirizzo} {d.cap} {d.citta} {d.provincia} {d.stato}</p>
                        <p><ShowOptionalField label="P.IVA" value={d.piva}/> <ShowOptionalField label="C.Fisc." value={d.cfisc}/>
                        </p>
                    </div>
                </div>
                <div className="content">
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Telefono 1</label><ShowOptionalLabel value={d.telefono1} icon="voulme control phone" extraClassName="right floated" />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Telefono 2</label><ShowOptionalLabel value={d.telefono2} icon="voulme control phone" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Cellulare</label><ShowOptionalLabel value={d.cellulare} icon="voulme control phone" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">FAX</label><ShowOptionalLabel value={d.fax} icon="fax" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">e-mail</label><ShowOptionalLabel value={d.email} icon="mail" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Web site</label><ShowOptionalLabel value={d.web} icon="web" extraClassName="right floated"  />
                    </div>
                </div>
                <div className="content">
                    <div className="ui vertical basic segment">
                        Creato il {d.creatoIl ?  <b><LocalDate data={d.creatoIl } /> <LocalTime data={d.creatoIl } /></b> : <b>?</b>} da <b>{d.creatoDa ? d.creatoDa.username : '?'}</b>
                    </div>
                    <div className="ui vertical basic segment">
                        <p>Modificato il {d.modificatoIl ?  <b><LocalDate data={d.modificatoIl } /> <LocalTime data={d.modificatoIl } /></b> : <b>?</b>} da <b>{d.modificatoDa ? d.modificatoDa.username : '?'}</b></p>
                    </div>
                </div>
                <div className="content">
                    <p>{d.note}</p>
                </div>
            </div>
            <div className="ui card">
                <div className="content">
                    <div className="header">
                        <i className={"industry icon" }/>
                        {o.nomeCompleto}
                    </div>
                </div>
                <div className="content">
                    <div className="header">
                        Indirizzo
                    </div>
                    <div className="description">
                        <p>{o.indirizzo} {o.cap} {o.citta} {o.provincia} {o.stato}</p>
                        <p><ShowOptionalField label="P.IVA" value={o.piva}/> <ShowOptionalField label="C.Fisc." value={o.cfisc}/>
                        </p>
                    </div>
                </div>
                <div className="content">
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Telefono 1</label><ShowOptionalLabel value={o.telefono1} icon="voulme control phone" extraClassName="right floated" />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Telefono 2</label><ShowOptionalLabel value={o.telefono2} icon="voulme control phone" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Cellulare</label><ShowOptionalLabel value={o.cellulare} icon="voulme control phone" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">FAX</label><ShowOptionalLabel value={o.fax} icon="fax" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">e-mail</label><ShowOptionalLabel value={o.email} icon="mail" extraClassName="right floated"  />
                    </div>
                    <div className="ui vertical basic segment">
                        <label className="ui left floated">Web site</label><ShowOptionalLabel value={o.web} icon="web" extraClassName="right floated"  />
                    </div>
                </div>
                <div className="content">
                    <div className="ui vertical basic segment">
                        Creato il {o.creatoIl ?  <b><LocalDate data={o.creatoIl } /> <LocalTime data={o.creatoIl } /></b> : <b>?</b>} da <b>{o.creatoDa ? o.creatoDa.username : '?'}</b>
                    </div>
                    <div className="ui vertical basic segment">
                        <p>Modificato il {o.modificatoIl ?  <b><LocalDate data={o.modificatoIl } /> <LocalTime data={o.modificatoIl } /></b> : <b>?</b>} da <b>{o.modificatoDa ? o.modificatoDa.username : '?'}</b></p>
                    </div>
                </div>
                <div className="content">
                    <p>{o.note}</p>
                </div>
            </div>

        </div>
        <LoadingFrame visible={loading}/>
    </div>

};

export default RubricaDetail;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaDetail.js
 **/